import React from "react";
import "./manifestView.css";
import Heading from "../Heading";
import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";

export class ManifestoPoint extends React.Component {
  constructor(args) {
    super(args);
    this.state = {};
    this.PointConstant = [
      {
        id: 0,
        pointText:
          "Winpe partners will step up efforts for diversity in hiring by pushing for a diverse talent pipeline and incorporating a blind screening process (including redacted CVs removing names and other indications of gender, case studies). The diversity targets for inward talent pipeline will be set on a confidential basis to maintain merit and credibility in hiring.",
      },
      {
        id: 1,
        pointText:
          "Winpe and its partners will support mid career women professionals from the industry through a structured mentorship program to be run by WinPE.",
      },
      {
        id: 2,
        pointText:
          "Winpe partners will introduce a conversation on diversity within their firms and portfolio companies, enhancing awareness and sensitization within the ecosystem.",
      },
      {
        id: 3,
        pointText:
          "Winpe partners will seek for their portfolio companies to measure appropriate diversity metrics and report annually.",
      },
      {
        id: 4,
        pointText:
          "Winpe partners will ask for commitment and measurement on Equal Pay at KMP level in portfolio companies.",
      },
      {
        id: 5,
        pointText:
          "Winpe partners will support outreach at campuses that are hiring grounds for the industry to champion awareness among female candidates.",
      },
    ];
  }
  render() {
    return (
      <div className="section__content">
        <div className="manifest__wrapper">
          <div className="manifest__section">
            <div className="manifest_content">
              <div className="low__heading"></div>
              <div className="">
                <Heading title="Winpe Partner Manifesto" />
              </div>
              <ScrollAnimation
                delay={0}
                duration={2}
                animateIn="slideInUp"
                offset={600}
              >
                <div className="manifest_intro_text">
                  <div className="intro_text">
                  Winpe mission partners have collectively identified the
                    following priorities for their joint action towards
                    enhancing gender diversity within the investing ecosystem:
                  </div>
                </div>
                <div className="manifest_point_section">
                  <div className="manifest_point_text">
                    <ol>
                      {this.PointConstant.map((item, i) => {
                        return (
                          <li key={i}>
                            <div>{item.pointText}</div>
                          </li>
                        );
                      })}
                    </ol>
                  </div>
                </div>
              </ScrollAnimation>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ManifestoPoint;



// WEBPACK FOOTER //
// ./src/components/ManifestoPoint/index.js